<!-- Equipment Management -->
<template>
  <div class="em-list-page">
    <div class="em-header">
      <button class="refresh-button" @click="loadData">새로고침</button>

      <div class="search-section">
        <div class="info-label" v-if="userInfo && userInfo.OGN_FG === '00'">본부</div>
        <select
          v-model="selectedBranch"
          class="branch-select"
          @change="onBranchChange"
          v-if="userInfo && userInfo.OGN_FG === '00'"
        >
          <option
            v-for="branch in branchList"
            :key="branch.BRANCH_NM"
            :value="branch.BRANCH_NM"
          >
            {{ branch.BRANCH_NM }}
          </option>
        </select>
        <div class="info-label" v-if="userInfo && userInfo.OGN_FG === '00'">매장명</div>
        <input
          type="text"
          placeholder="검색"
          @input="onQuickFilterChanged"
          class="search-input"
          v-if="userInfo && userInfo.OGN_FG === '00'"
        />
      </div>
      <div class="em-title">&lt; 장비관리 &gt;</div>
      <table class="em-req-cnt">
        <tbody>
          <tr>
            <th>당월요청</th>
            <td>{{ monthlyRequests.toLocaleString() }}</td>
            <th>당월완료</th>
            <td>{{ monthlyCompleted.toLocaleString() }}</td>
            <th>전체대기수</th>
            <td>{{ totalWaiting.toLocaleString() }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="em-total-cnt" v-if="this.userInfo?.OGN_FG == '00'">
      <table class="em-total-table">
        <thead>
          <tr>
            <th style="width: 70px;"></th>
            <th style="width: 80px;"></th>
            <th>리프트</th>
            <th>탈부착기</th>
            <th>밸런스기</th>
            <th>휠라이프트</th>
            <th>타이어탈착</th>
            <th>에어메이트</th>
            <th>콤프레샤</th>
            <th>비드부스터</th>
            <th>체인리프트</th>
            <th>전기시설</th>
            <th>기타요청</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2">보유계</td>
            <td v-for="i in 11" :key="'total' + i" style="text-align: right">
              {{ getTotalDV("DV" + i).toLocaleString() }}
            </td>
          </tr>
          <tr>
            <td colspan="2">매장</td>
            <td v-for="i in 11" :key="'m' + i" style="text-align: right">
              {{ getDV("매장", "DV" + i).toLocaleString() }}
            </td>
          </tr>
          <tr>
            <td rowspan="2">청원</td>
            <td>신품</td>
            <td v-for="i in 11" :key="'cs' + i" style="text-align: right">
              <input
                v-if="userInfo?.EMP_DEPT_NM === '장비팀'"
                type="number"
                v-model.number="getDVRow('청원신품')['DV' + i]"
                @change="updateTotalDV(i, 3, getDVRow('청원신품')['DV' + i])"
                class="em-total-input"
              />
              <span v-else>{{ getDV("청원신품", "DV" + i).toLocaleString() }}</span>
            </td>
          </tr>
          <tr>
            <td>중고</td>
            <td v-for="i in 11" :key="'cj' + i" style="text-align: right">
              <input
                v-if="userInfo?.EMP_DEPT_NM === '장비팀'"
                type="number"
                v-model.number="getDVRow('청원중고')['DV' + i]"
                @change="updateTotalDV(i, 4, getDVRow('청원중고')['DV' + i])"
                class="em-total-input"
              />
              <span v-else>{{ getDV("청원중고", "DV" + i).toLocaleString() }}</span>
            </td>
          </tr>

          <tr>
            <td rowspan="2">설치예정</td>
            <td>신규오픈</td>
            <td v-for="i in 11" :key="'no' + i" style="text-align: right">
              <input
                v-if="userInfo?.EMP_DEPT_NM === '장비팀'"
                type="number"
                v-model.number="getDVRow('신규오픈')['DV' + i]"
                @change="updateTotalDV(i, 5, getDVRow('신규오픈')['DV' + i])"
                class="em-total-input"
              />
              <span v-else>{{ getDV("신규오픈", "DV" + i).toLocaleString() }}</span>
            </td>
          </tr>
          <tr>
            <td>추가설치</td>
            <td v-for="i in 11" :key="'as' + i" style="text-align: right">
              <input
                v-if="userInfo?.EMP_DEPT_NM === '장비팀'"
                type="number"
                v-model.number="getDVRow('추가설치')['DV' + i]"
                @change="updateTotalDV(i, 6, getDVRow('추가설치')['DV' + i])"
                class="em-total-input"
              />
              <span v-else>{{ getDV("추가설치", "DV" + i).toLocaleString() }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2">부족분</td>
            <td
              v-for="i in 11"
              :key="'lack' + i"
              :class="{ 'text-critical': getLackDV('DV' + i) < 0 }"
              style="text-align: right"
            >
              {{ getLackDV("DV" + i).toLocaleString() }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="em-device-list">
      <!-- AG Grid 테이블 -->
      <ag-grid-vue
        class="ag-em-balham"
        :style="{ width: '100%' }"
        :columnDefs="deviceColumnDefs"
        :rowData="deviceListData"
        :gridOptions="gridOptions"
        :theme="theme"
        @grid-ready="onGridReady"
        @cell-double-clicked="onCellDoubleClicked"
      />
    </div>

    <!-- 장비 상세 내역 팝업 (VB의 spGearList 역할) -->
    <div v-if="showGearModal" class="gear-modal-overlay">
      <div class="gear-modal">
        <div class="gear-header">
          <div class="gear-title">
            <strong>장비 상세 내역:</strong> {{ modalShopNm }} ({{
              modalItemNm
            }})
          </div>
          <button class="gear-close" @click="closeGearModal">X</button>
        </div>
        <div class="gear-body">
          <table class="detail-table">
            <thead>
              <tr>
                <!-- <th>No</th>
                <th>매장명</th>
                <th>항목</th>
                <th>브랜드</th>
                <th>최초설치</th>
                <th>설치상태</th>
                <th>사용연한<br>(단위:개월)</th>
                <th>상태</th>
                <th>신청일</th>
                <th>관리자</th>
                <th>예정일</th>
                <th>완료일</th>
                <th>비고</th>
                <th>수리요청</th> -->
                <th style="width: 2%">No</th>
                <th style="width: 9%">매장명</th>
                <th style="width: 7%">항목</th>
                <th style="width: 8%">브랜드</th>
                <th style="width: 7%">최초설치</th>
                <th style="width: 3%">설치상태</th>
                <th style="width: 7%">사용연한<br />(단위:개월)</th>
                <th style="width: 3%">상태</th>
                <th style="width: 7%">신청일</th>
                <th style="width: 5%">관리자</th>
                <th style="width: 7%">예정일</th>
                <th style="width: 7%">완료일</th>
                <th style="width: 15%">비고</th>
                <th style="width: 7%">
                  {{ this.userInfo?.EMP_DEPT_NM === '장비팀' ? '접수' : '수리요청' }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="(item, idx) in gearListData" 
                :key="idx" 
                @dblclick="onGearRowDoubleClicked(item)"
                style="cursor: pointer"
              >
                <td>{{ idx + 1 }}</td>
                <td>{{ item.SHOP_NM }}</td>
                <td>{{ item.ITEM_NM }}</td>
                <td>{{ item.BRAND_NM }}</td>
                <td>{{ item.SET_DATE.substring(0, 10) }}</td>
                <td>{{ item.STATE_NM }}</td>
                <td>{{ item.PERSISTING_PERIOD }}</td>
                <td>{{ item.CONDITION_NM }}</td>
                <td>{{ item.REQ_DATE }}</td>
                <td>{{ item.CHECK_EMP_NM }}</td>
                <td>{{ item.CHECK_DATE }}</td>
                <td>{{ item.COMPLAT_DATE }}</td>
                <td>{{ item.ETC }}</td>
                <!-- <td>
                  <input
                    v-if="item.CONDITION_NM === '정상'"
                    v-model="item.ETC"
                    placeholder="요청사항 입력"
                    class="etc-input"
                  />
                  <span v-else>{{ item.ETC }}</span>
                </td> -->
                <td>
                  <button
                    v-if="item.CONDITION_NM === '정상' &&
                      this.userInfo?.EMP_DEPT_NM !== '장비팀'"
                    @click="handleAction('수리요청', item)"
                  >
                    수리요청
                  </button>
                  <button
                    v-if="
                      item.CONDITION_NM === '요청' &&
                      this.userInfo?.EMP_DEPT_NM == '장비팀'
                    "
                    @click="handleAction('접수', item)"
                  >
                    접수
                  </button>
                  <button
                    v-if="item.CONDITION_NM === '접수'"
                    @click="handleAction('완료', item)"
                  >
                    완료
                  </button>
                </td>
              </tr>
              <tr v-if="gearListData.length === 0">
                <td colspan="14">데이터가 없습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="gear-footer">
          <button
            v-if="this.userInfo?.EMP_DEPT_NM === '장비팀'"
            @click="openAddGearModal"
            style="float: left; background-color: #4a90e2; color: white"
          >
            신규등록
          </button>
          <div v-if="this.userInfo?.EMP_DEPT_NM === '장비팀'" style="float: left;">&nbsp;&nbsp;※ 장비 수정 방법 -> 해당 줄(row) 더블 클릭</div>
          <button @click="closeGearModal">닫기</button>
        </div>
      </div>
    </div>

    <!-- 비고 입력 모달 (수리요청 시) -->
    <div v-if="showEtcModal" class="etc-modal-overlay">
      <div class="etc-modal">
        <div class="etc-modal-header">
          <div class="etc-modal-title">수리요청 비고 입력</div>
          <button class="etc-modal-close" @click="showEtcModal = false">
            X
          </button>
        </div>
        <div class="etc-modal-body">
          <label style="font-weight: bold; font-size: 0.9rem"
            >요청사항(비고):</label
          >
          <textarea
            v-model="etcInput"
            placeholder="수리 요청 내용을 상세히 입력하세요."
            class="etc-textarea"
            maxlength="100"
          ></textarea>
          <div>{{ etcInput.length }}/100</div>
        </div>
        <div class="etc-modal-footer">
          <button class="etc-btn-submit" @click="submitRepairRequest">
            요청완료
          </button>
          <button class="etc-btn-cancel" @click="showEtcModal = false">
            취소
          </button>
        </div>
      </div>
    </div>

    <!-- 접수 처리 모달 (예정일 입력) -->
    <div v-if="showAcceptModal" class="etc-modal-overlay">
      <div class="etc-modal">
        <div class="etc-modal-header">
          <div class="etc-modal-title">장비 수리 접수</div>
          <button class="etc-modal-close" @click="showAcceptModal = false">X</button>
        </div>
        <div class="etc-modal-body">
          <label style="font-weight: bold; font-size: 0.9rem">수리 예정일자(예정일):</label>
          <input type="date" v-model="checkDateInput" class="etc-input-date" />
        </div>
        <div class="etc-modal-footer">
          <button class="etc-btn-submit" @click="submitAcceptance">접수완료</button>
          <button class="etc-btn-cancle" @click="showAcceptModal = false">취소</button>
        </div>
      </div>
    </div>

    <!-- 장비 신규 등록 모달 (장비팀 전용) -->
    <div v-if="showAddGearModal" class="etc-modal-overlay">
      <div class="etc-modal" style="width: 450px">
        <div class="etc-modal-header">
          <div class="etc-modal-title">장비 관리</div>
          <button class="etc-modal-close" @click="showAddGearModal = false">X</button>
        </div>
        <div class="etc-modal-body">
          <div class="form-item">
            <label>매장명:</label>
            <input type="text" :value="modalShopNm" disabled class="etc-input-date" />
          </div>
          <div class="form-item">
            <label>항목:</label>
            <select v-model="modalItemCd" class="etc-input-date" @change="onItemChange">
              <option value="">항목 선택</option>
              <option v-for="opt in itemsOptions" :key="opt.lITEM_CD" :value="opt.lITEM_CD">
                {{ opt.sITEM_NM }}
              </option>
            </select>
          </div>
          <div class="form-item">
            <label>브랜드:</label>
            <div class="combo-wrapper">
            <input
              type="text"
              v-model="addGearForm.brandNm"
              class="etc-input-date"
              @focus="showBrandDropdown = true"
              @input="showBrandDropdown = true"
              @blur="hideDropdown"
            />

            <ul v-if="showBrandDropdown" class="dropdown" style="cursor: pointer">
              <li
                v-for="opt in filteredBrands"
                :key="opt.lITEM_CD"
                @click="selectBrand(opt.sITEM_NM)"
              >
                {{ opt.sITEM_NM }}
              </li>
            </ul>
          </div>

          </div>
          <div class="form-item">
            <label>최초설치:</label>
            <input type="date" v-model="addGearForm.setDate" class="etc-input-date" />
          </div>
          <div class="form-item">
            <label>설치상태:</label>
            <select v-model="addGearForm.stateNm" class="etc-input-date">
              <option v-for="opt in statesOptions" :key="opt.lITEM_CD" :value="opt.sITEM_NM">
                {{ opt.sITEM_NM }}
              </option>
            </select>
          </div>
          <div class="form-item">
            <label>사용연한(개월):</label>
            <select v-model="addGearForm.persistingPeriod" class="etc-input-date">
              <option value="">개월 선택</option>
              <option v-for="n in 60" :key="n" :value="n">
                {{ n }}
              </option>
            </select>
          </div>
          <div class="form-item">
            <label>비고:</label>
            <textarea v-model="addGearForm.remark" placeholder="기타 특이사항 입력" class="etc-textarea" style="height: 60px"></textarea>
          </div>
        </div>
        <div class="etc-modal-footer">
          <button v-if="editingLid" class="etc-btn-submit collect" @click="collectGear">회수</button>
          <button v-if="editingLid" class="etc-btn-submit delete" @click="deleteGear">삭제</button>
          <button class="etc-btn-submit" @click="saveGear">저장</button>
          <button class="etc-btn-cancle" @click="showAddGearModal = false">취소</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import { themeBalham } from "ag-grid-community";
import axios from "axios";

export default {
  name: "EmListPage",
  components: { AgGridVue },
  data() {
    return {
      selectedBranch: "", // 선택된 본부
      branchList: [],

      quickFilterText: "",
      gridApi: null,

      monthlyRequests: 0,
      monthlyCompleted: 0,
      totalWaiting: 0,

      deviceTotalData: [],

      selectedShop: "",

      // 팝업 관련 상태
      showGearModal: false,
      gearListData: [],
      modalShopNm: "",
      modalItemNm: "",
      modalShopCd: "",
      modalItemCd: "",
      editingLid: 0,

      // 비고 입력 모달 관련
      showEtcModal: false,
      etcInput: "",
      currentActionItem: null,

      // 접수 모달
      showAcceptModal: false,
      checkDateInput: "",

      // 신규 등록 모달 관련
      showAddGearModal: false,
      brandsOptions: [], // VB: MakerList_Load (Index 6)
      statesOptions: [], // VB: StateList_Load (Index 3)
      itemsOptions: [],
      addGearForm: {
        brandNm: "",
        setDate: new Date().toISOString().substring(0, 10),
        stateNm: "",
        persistingPeriod: 0,
        remark: "",
      },
      showBrandDropdown: false,


      deviceListData: [],
      deviceColumnDefs: [
        {
          headerName: "No",
          valueGetter: "node.rowIndex + 1",
          flex: 0.4,
          cellStyle: { textAlign: "center", backgroundColor: "#D2FFE8" },
        },
        {
          headerName: "점번",
          field: "VAN_BIZ_NO",
          flex: 0.4,
          cellStyle: { textAlign: "center" },
        },
        {
          headerName: "매장명",
          field: "SHOP_NM",
          flex: 1.2,
          cellStyle: { textAlign: "left" },
        },
        {
          headerName: "매장전화",
          field: "TEL_NO",
          flex: 1.1,
          cellStyle: { textAlign: "center" },
        },
        // 장비 컬럼들 (DV4 ~ DV14)
        {
          headerName: "리프트",
          field: "IT1",
          flex: 0.7,
          cellStyle: (params) =>
            this.getDeviceCellStyle(params, "ITS1", "CMS1"),
        },
        {
          headerName: "탈부착기",
          field: "IT2",
          flex: 0.7,
          cellStyle: (params) =>
            this.getDeviceCellStyle(params, "ITS2", "CMS2"),
        },
        {
          headerName: "밸런스기",
          field: "IT3",
          flex: 0.7,
          cellStyle: (params) =>
            this.getDeviceCellStyle(params, "ITS3", "CMS3"),
        },
        {
          headerName: "얼라이먼트",
          field: "IT4",
          flex: 0.9,
          cellStyle: (params) =>
            this.getDeviceCellStyle(params, "ITS4", "CMS4"),
        },
        {
          headerName: "타이어호텔",
          field: "IT5",
          flex: 0.9,
          cellStyle: (params) =>
            this.getDeviceCellStyle(params, "ITS5", "CMS5"),
        },
        {
          headerName: "에어메이트",
          field: "IT6",
          flex: 0.9,
          cellStyle: (params) =>
            this.getDeviceCellStyle(params, "ITS6", "CMS6"),
        },
        {
          headerName: "콤프레샤",
          field: "IT7",
          flex: 0.7,
          cellStyle: (params) =>
            this.getDeviceCellStyle(params, "ITS7", "CMS7"),
        },
        {
          headerName: "비드부스터",
          field: "IT8",
          flex: 0.9,
          cellStyle: (params) =>
            this.getDeviceCellStyle(params, "ITS8", "CMS8"),
        },
        {
          headerName: "체인리프트",
          field: "IT9",
          flex: 0.9,
          cellStyle: (params) =>
            this.getDeviceCellStyle(params, "ITS9", "CMS9"),
        },
        {
          headerName: "전기시설",
          field: "IT10",
          flex: 0.7,
          cellStyle: (params) =>
            this.getDeviceCellStyle(params, "ITS10", "CMS10"),
        },
        {
          headerName: "기타요청",
          field: "IT11",
          flex: 0.7,
          cellStyle: (params) =>
            this.getDeviceCellStyle(params, "ITS11", "CMS11"),
        },
        {
          headerName: "접수",
          field: "SERVICE",
          flex: 0.5,
          cellStyle: { textAlign: "right" },
        },
        {
          headerName: "완료",
          field: "COMPLAT_CNT",
          flex: 0.5,
          cellStyle: { textAlign: "right" },
        },
        { field: "SHOP_CD", hide: true },
      ],

      gridOptions: {
        headerHeight: 20,
        rowHeight: 20,
        quickFilterText: "",
        defaultColDef: {
          sortable: true,
          resizable: true,
        },
      },

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),
    };
  },
  // computed: {
  //   filteredEquipList() {
  //     if (!this.selectedShop) return this.equipList;
  //     return this.equipList.filter((item) => item.shopCd === this.selectedShop);
  //   },
  // },
  computed: {
    filteredBrands() {
      if (!this.addGearForm.brandNm) return this.brandsOptions;
      const search = this.addGearForm.brandNm.toLowerCase();
      return this.brandsOptions.filter((opt) =>
        opt.sITEM_NM.toLowerCase().includes(search)
      );
    },
  },

  created() {
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }

    this.fetchBranchList();
  },

  mounted() {
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }

    this.loadDeviceReqCntData();
    this.loadDeviceTotalData();
    this.loadDeviceListData();

    // 항목 리스트 로드 (VB Index 2)
    this.fetchGearList(2).then(res => {
      this.itemsOptions = res;
    });

    // 설치상태 리스트 로드 (VB Index 3)
    this.fetchGearList(3).then(res => {
      this.statesOptions = res;
    });

  },

  methods: {
    async fetchBranchList() {
      try {
        const res = await axios.get("/api/emListPage/center");
        this.branchList = res.data;
        if (this.branchList && this.branchList.length > 0) {
          this.selectedBranch = this.branchList[0].BRANCH_NM; // 기본값으로 첫 번째 본부 선택
        }
      } catch (error) {
        console.error("본부 목록 로딩 실패:", error);
        alert("본부 목록을 불러오는 데 실패했습니다.");
      }
    },
    async loadDeviceReqCntData() {
      try {
        // SP_DEVICE_MG_CNT 조회를 위한 API 호출
        const response = await axios.get("/api/emListPage/deviceReqCntData");
        const data = response.data[0];
        // 프로시저 결과 매핑

        this.monthlyRequests = data.MM_REQ_CNT || 0;
        this.monthlyCompleted = data.MM_COMP_CNT || 0;
        this.totalWaiting = data.WAIT_CNT || 0;
      } catch (error) {
        console.error("장비 요청수 데이터 조회 실패:", error);
      }
    },

    async loadDeviceTotalData() {
      try {
        // 장비 전체 현황 조회를 위한 API 호출
        const response = await axios.get("/api/emListPage/deviceTotalData");
        this.deviceTotalData = response.data;
      } catch (error) {
        console.error("장비 통계 데이터 조회 실패:", error);
      }
    },

    getDV(stat, dv) {
      if (!this.deviceTotalData || this.deviceTotalData.length === 0) return 0;
      const row = this.deviceTotalData.find((item) => item.STAT === stat);
      return row ? Number(row[dv] || 0) : 0;
    },

    getDVRow(stat) {
      return this.deviceTotalData.find((item) => item.STAT === stat) || {};
    },

    async updateTotalDV(col, row, val) {
      try {
        // VB: EXEC SP_IU_DEVICE_TOTAL Col, Row, vVAL
        await axios.post("/api/emListPage/updateDeviceTotal", {
          col: col,
          row: row,
          val: val || 0,
        });
        // 값 변경 후 보유계 및 부족분 재계산을 위해 데이터 리로드
        await this.loadDeviceTotalData();
        alert("저장되었습니다");
      } catch (error) {
        console.error("장비 통계 수정 실패:", error);
      }
    },

    getTotalDV(dv) {
      // 보유계 = 매장 + 청원신품 + 청원중고
      return (
        this.getDV("매장", dv) +
        this.getDV("청원신품", dv) +
        this.getDV("청원중고", dv)
      );
    },

    getLackDV(dv) {
      // SUM(3:4) - SUM(5:6) 로직 적용
      // (청원신품 + 청원중고) - (신규오픈 + 추가설치)
      const available = this.getDV("청원신품", dv) + this.getDV("청원중고", dv);
      const planned = this.getDV("신규오픈", dv) + this.getDV("추가설치", dv);
      return available - planned;
    },

    async loadDeviceListData() {
      try {
        const params = {};
        //변수 EXEC Restoredata.dbo.SP_S_DEVICE_STORE_V1 1, '${shopCd}','${itemCd}','${branchNm}'
        params.index = 1;
        params.itemCd = 0;
        params.branchNm = this.selectedBranch ? this.selectedBranch : "전체";
        params.shopCd =
          this.userInfo.OGN_FG === "01" ? this.userInfo.SHOP_CD : "";

        const response = await axios.get("/api/emListPage/deviceListData", {
          params,
        });
        this.deviceListData = response.data;
      } catch (error) {
        console.error("장비 리스트 데이터 조회 실패:", error);
      }
    },

    getDeviceCellStyle(params, s1Field, s2Field) {
      if (!params.data) return null;
      // VB 로직: s1(Red) 체크 -> s2(Yellow) 체크 -> 기본(White)
      if (Number(params.data[s1Field] || 0) !== 0) {
        return {
          backgroundColor: "#FF0000",
          color: "#FFFFFF",
          textAlign: "right",
          cursor: "pointer",
        };
      } else if (Number(params.data[s2Field] || 0) !== 0) {
        return {
          backgroundColor: "#FFF200",
          color: "#000000",
          textAlign: "right",
          cursor: "pointer",
        };
      }
      return { textAlign: "right", cursor: "pointer" };
    },

    async onCellDoubleClicked(params) {
      const field = params.colDef.field;
      let itemCd = "";
      if(field === "SERVICE" || field === "COMPLAT_CNT"){
        return;
      }
      if (field && field.startsWith("IT")) {
        itemCd = parseInt(field.replace("IT", "")) + 3; // 'IT1' -> '1' 인데 vb에선 콜순서로 가져옴
      } else {
        itemCd = 1;
      }
      const shopCd = params.data.SHOP_CD;

      this.modalShopNm = params.data.SHOP_NM;
      this.modalItemNm = params.colDef.headerName;
      this.modalShopCd = shopCd;
      this.modalItemCd = itemCd;

      try {
        // VB: EXEC SP_S_DEVICE_STORE_V1 4, vStore_Cd, Col, ''
        const response = await axios.get("/api/emListPage/deviceDetailData", {
          params: {
            index: 4,
            shopCd: shopCd,
            itemCd: itemCd,
          },
        });
        this.gearListData = response.data;
        this.showGearModal = true;
      } catch (error) {
        console.error("상세 데이터 조회 실패:", error);
        alert("상세 내역을 가져오는데 실패했습니다.");
      }
    },

    closeGearModal() {
      this.showGearModal = false;
      this.gearListData = [];
    },

    handleAction(action, item) {
      if (action === "수리요청") {
        this.currentActionItem = item;
        this.etcInput = item.ETC || "";
        this.showEtcModal = true;
      } else if (action === "접수") {
        this.currentActionItem = item;
        // 오늘 날짜를 기본값으로 설정하여 달력이 선택된 상태로 보이게 함
        this.checkDateInput = new Date().toISOString().substring(0, 10);
        this.showAcceptModal = true;
      } else if (action === "완료"){
        this.executeAction(action, item, item.ETC, null);
      }
    },

    async submitRepairRequest() {
      if (!this.etcInput || this.etcInput.trim() === "") {
        alert("비고(요청사항)를 입력해주세요.");
        return;
      }

      if (this.etcInput.length > 100) {
        alert("비고(요청사항)는 100자 이내로 입력해주세요.");
        return;
      }

      await this.executeAction("수리요청", this.currentActionItem, this.etcInput, null);
      this.showEtcModal = false;
    },

    async submitAcceptance() {
      if (!this.checkDateInput) {
        alert("수리 예정일을 선택해주세요.");
        return;
      }
      await this.executeAction("접수", this.currentActionItem, this.currentActionItem.ETC, this.checkDateInput);
      this.showAcceptModal = false;
    },

    async executeAction(action, item, etc, checkDate) {
      if (!confirm(`'${action}' 처리를 하시겠습니까?`)) return;

      try {
        const payload = {
          lID: item.lID,
          etc: etc || "",
          userId: this.userInfo.userId,
          action: action, // '수리요청', '접수', '완료'
          checkEmpNm: this.userInfo.EMP_NM,
          checkDate: checkDate,
        };

        // 백엔드 API 호출 (VB의 UPDATE T_DEVICE 로직 처리)
        await axios.post("/api/emListPage/updateGearStatus", payload);
        alert("처리가 완료되었습니다.");

        // 팝업 내 상세 리스트 데이터 새로고침
        const response = await axios.get("/api/emListPage/deviceDetailData", {
          params: {
            index: 4,
            shopCd: this.modalShopCd,
            itemCd: this.modalItemCd,
          },
        });
        this.gearListData = response.data;

        // 메인 화면의 통계 및 장비 리스트 데이터 갱신
        this.loadDeviceReqCntData();
        this.loadDeviceListData();
      } catch (error) {
        console.error(`${action} 처리 실패:`, error);
        alert("처리 중 오류가 발생했습니다.");
      }
    },

    async fetchGearList(index, value = "") {
      try {
        const res = await axios.get("/api/emListPage/gearList", {
          params: { index, value },
        });
        return res.data; // [{ CD: 1, NM: '...' }, ...]
      } catch (e) {
        console.error("옵션 로드 실패:", e);
        return [];
      }
    },

    async openAddGearModal() {
      // 항목 리스트 로드 (VB Index 2)
      // this.itemsOptions = await this.fetchGearList(2);
      // 설치상태 리스트 로드 (VB Index 3)
      // this.statesOptions = await this.fetchGearList(3);
      // 브랜드 리스트 로드 (VB Index 6, 현재 항목 기준)
      // this.brandsOptions = await this.fetchGearList(6, this.modalItemNm);
      this.modalItemCd = "";
      this.editingLid = 0;
      this.brandsOptions = [];
      
      this.addGearForm = {
        brandNm: "",
        setDate: new Date().toISOString().substring(0, 10),
        stateNm: this.statesOptions.length > 0 ? this.statesOptions[0].sITEM_NM : "",
        persistingPeriod: 1,
        remark: "",
      };
      this.showAddGearModal = true;
    },

     async onItemChange() {
      // 선택된 CD에 해당하는 이름을 찾아서 modalItemNm 업데이트 (Index 6 조회를 위해)
      const selectedItem = this.itemsOptions.find(opt => opt.lITEM_CD === this.modalItemCd);
      if (selectedItem) {
        this.modalItemNm = selectedItem.sITEM_NM;
        // 해당 항목에 맞는 브랜드 리스트 다시 로드
        this.brandsOptions = await this.fetchGearList(6, this.modalItemNm);
        this.addGearForm.brandNm = ""; // 브랜드 초기화
      }
    },

    async onGearRowDoubleClicked(item) {
      // 장비팀 권한 체크
      if (this.userInfo?.EMP_DEPT_NM !== '장비팀') return;

      // 필요한 옵션 리스트 로드
      // this.itemsOptions = await this.fetchGearList(2);
      // this.statesOptions = await this.fetchGearList(3);
      
      // 선택된 장비의 항목 명칭으로 브랜드 목록 로드
      this.brandsOptions = await this.fetchGearList(6, item.ITEM_NM);

      // 현재 항목 코드(ID) 동기화
      const foundItem = this.itemsOptions.find(opt => opt.sITEM_NM === item.ITEM_NM);
      if (foundItem) {
        this.editingLid = item.lID;
        this.modalItemCd = foundItem.lITEM_CD;
        this.modalItemNm = foundItem.sITEM_NM;
      }

      // 브랜드 값 세팅
      const brandNm = item.BRAND_NM || "";

      // 옵션에 없는 브랜드면 자동 추가
      const exists = this.brandsOptions.some(opt => opt.sITEM_NM === brandNm);
      if (!exists && brandNm) {
        this.brandsOptions.push({
          lITEM_CD: -1,        // 임시 코드
          sITEM_NM: brandNm    // 표시 텍스트
        });
      }

      // 폼 데이터에 선택한 행의 정보 입력
      this.addGearForm = {
        brandNm, // 이제 select에서 정상적으로 표시됨
        setDate: item.SET_DATE ? item.SET_DATE.substring(0, 10) : new Date().toISOString().substring(0, 10),
        stateNm: item.STATE_NM || "",
        persistingPeriod: item.PERSISTING_PERIOD || 0,
        remark: item.ETC || "",
      };
      this.showAddGearModal = true;
    },

    async saveGear() {
      // VB 유효성 검사 로직 구현
      if (!this.modalItemCd) {
        alert("항목을 선택해 주세요.");
        return;
      }
      if (!this.addGearForm.brandNm || this.addGearForm.brandNm.trim() === "") {
        alert("브랜드를 선택해 주세요.");
        return;
      }
      if (!this.addGearForm.stateNm) {
        alert("설치상태를 선택해 주세요.");
        return;
      }
      if (this.addGearForm.persistingPeriod === "") {
        alert("사용연한을 선택해 주세요.");
        return;
      }

      if (!confirm("장비 정보를 저장하시겠습니까?")) return;

      try {
        // VB: Combo.ListIndex + 1 방식의 인덱스 추출
        const itemIdx = this.itemsOptions.findIndex(opt => opt.lITEM_CD === this.modalItemCd) + 1;
        const stateIdx = this.statesOptions.findIndex(opt => opt.sITEM_NM === this.addGearForm.stateNm) + 1;
        const payload = {
          lID: this.editingLid,
          shopCd: this.modalShopCd,
          itemCd: itemIdx,
          stateCd: stateIdx,
          periodCd: this.addGearForm.persistingPeriod,
          userId: this.userInfo.userId,
          ...this.addGearForm,
        };
        
        await axios.post("/api/emListPage/saveGear", payload);
        alert("저장되었습니다.");
        this.showAddGearModal = false;
        // 팝업 리스트 및 메인 그리드 갱신
        await this.refreshGearPopList();
        this.loadDeviceListData();
      } catch (error) {
        console.error("장비 등록 실패:", error);
        alert("저장 중 오류가 발생했습니다.");
      }
    },

    async deleteGear() {
      if (!this.editingLid) return;
      if (!confirm("항목을 삭제하시겠습니까?")) return;

      try {
        // VB: UPDATE T_DEVICE SET DELETED = 1 ... (DELETED = 1: 삭제)
        await axios.post("/api/emListPage/updateGearStatus", {
          lID: this.editingLid,
          userId: this.userInfo.userId,
          action: "삭제" 
        });
        alert("삭제되었습니다.");
        this.showAddGearModal = false;
        await this.refreshGearPopList();
        this.loadDeviceListData();
      } catch (error) {
        alert("삭제 중 오류가 발생했습니다.");
      }
    },

    async collectGear() {
      if (!this.editingLid) return;
      if (!confirm("회수 처리를 하시겠습니까?")) return;

      try {
        // VB: UPDATE T_DEVICE SET DELETED = 2 ... (DELETED = 2: 회수)
        await axios.post("/api/emListPage/updateGearStatus", {
          lID: this.editingLid,
          userId: this.userInfo.userId,
          action: "회수"
        });
        alert("회수되었습니다.");
        this.showAddGearModal = false;
        await this.refreshGearPopList();
        this.loadDeviceListData();
      } catch (error) {
        alert("회수 중 오류가 발생했습니다.");
      }
    },

    async refreshGearPopList() {
      console.log(this.modalItemCd,"refresh-->", parseInt(this.modalItemCd) + 3)
      const response = await axios.get("/api/emListPage/deviceDetailData", {
        params: { index: 4, shopCd: this.modalShopCd, itemCd: parseInt(this.modalItemCd) + 3}, //프로시저 조회시 - 3 
      });
      this.gearListData = response.data;
    },

    onBranchChange() {
      // 본부 변경 시 장비 리스트를 다시 조회합니다.
      this.loadDeviceListData();
    },

    onGridReady(params) {
      this.gridApi = params.api;
    },

    hideDropdown() {
      // 드롭다운 리스트 클릭 이벤트를 보장하기 위해 약간의 지연 후 닫습니다.
      setTimeout(() => {
        this.showBrandDropdown = false;
      }, 200);
    },

    onQuickFilterChanged(event) {
      const filterValue = event.target.value; // 입력 필드 값 가져오기
      if (this.gridApi) {
        this.gridApi.setGridOption("quickFilterText", filterValue); // quickFilter 적용
      } else {
        console.error("Grid API is not initialized.");
      }
    },
    
    selectBrand(name) {
      this.addGearForm.brandNm = name;
      this.showBrandDropdown = false;
    },
    loadData() {
      // TODO: 향후 실제 API 요청으로 교체
      this.loadDeviceReqCntData();
      this.loadDeviceTotalData();
      this.loadDeviceListData();
      alert("장비관리 데이터를 새로고침했습니다.");
    },
  },
};
</script>

<style scoped>
.em-list-page {
  padding: 3px;
  font-family: "Malgun Gothic", sans-serif;
}
.em-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 4px;
  margin-bottom: 1px;
}

.search-input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 6.25rem;
}

.em-title {
  font-size: 1.125rem;
  font-weight: bold;
}

.em-req-cnt {
  border-collapse: collapse;
  font-size: 0.8rem;
}
.em-req-cnt th {
  border: 1px solid black;
  background-color: #a7cdfc;
  text-align: center;
  padding: 4px;
}

.em-req-cnt td {
  border: 1px solid black;
  text-align: center;
  padding: 4px;
  width: 2.5rem;
}

.em-total-cnt {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 2px;
}

.em-total-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.7rem;
}

.em-total-table th {
  border: 1px solid black;
  text-align: center;
  padding: 4px;
  background-color: #d2ffe8;
  font-weight: bold;
}

.em-total-table td {
  border: 1px solid black;
  text-align: center;
  padding: 4px;
}

/* 장비 집계 테이블의 행 제목(좌측 라벨) 부분 배경색 설정 */
.em-total-table tbody td:not(:nth-last-child(-n + 11)) {
  background-color: #d2ffe8;
  font-weight: bold;
}

.search-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-section select {
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

.em-total-input {
  width: 100%;
  border: none;
  text-align: right;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
  padding: 0;
  box-sizing: border-box;
}
.em-total-input:focus {
  outline: 1px solid #4a90e2;
  background: white;
}
.em-total-input::-webkit-outer-spin-button,
.em-total-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.em-total-input[type=number] {
  appearance: textfield;        /* 표준 */
  -moz-appearance: textfield;   /* Firefox */
}

.refresh-button {
  border: 1px solid #2b3a67;
  background: #2b3a67;
  color: white;
  padding: 4px 8px;
  border-radius: 3px;
  cursor: pointer;
  width: 80px;
  height: 30px;
  font-size: 14px;
  justify-content: center;
}

.shop-name {
  text-align: left;
  padding-left: 8px;
}

:deep(.ag-em-balham) {
  height: calc(100vh - 350px);
  --ag-cell-horizontal-padding: 3px; /* 셀 내부 좌우 패딩 */
}

:deep(.ag-em-balham .ag-cell) {
  font-size: 0.72rem;
  text-align: right;
  /* padding-right: 3px; */
}

:deep(.ag-em-balham .ag-header-cell-comp-wrapper) {
  display: flex;
  background-color: #d2ffe8;
  align-items: center;
  justify-content: center;
  color: black;
}

:deep(.ag-header-cell-label) {
  justify-content: center;
}

:deep(.ag-em-balham .ag-header-cell-text) {
  font-size: 0.7rem;
}

/* 팝업 모달 스타일 */
.gear-modal-overlay {
  position: fixed;
  inset: 0;
  background: #0000007f;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.gear-modal {
  width: 98%;
  max-width: 1400px;
  max-height: 80vh;
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 15px #0000004d;
}
.gear-header {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  background: #f2f2f2;
  border-bottom: 1px solid #ddd;
}
.gear-title {
  font-weight: bold;
  font-size: 1rem;
}
.gear-close {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 1.2rem;
}
.gear-body {
  padding: 15px;
  overflow-y: auto;
  flex: 1;
}
.gear-footer {
  padding: 10px;
  border-top: 1px solid #eee;
  text-align: right;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem;
}
.detail-table th,
.detail-table td {
  border: 1px solid #ccc;
  padding: 2px;
  text-align: center;
}
.detail-table td:nth-child(13) {
  text-align: left;
}

.detail-table th {
  background: #d2ffe8;
}
.detail-table button {
  padding: 2px 8px;
  background: #a7cdfc;
  border: 1px solid #999;
  border-radius: 3px;
  cursor: pointer;
  font-size: 0.75rem;
}
.text-left {
  text-align: left !important;
}

/* 비고 입력 모달 스타일 */
.etc-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}
.etc-modal {
  width: 400px;
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}
.etc-modal-header {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  background: #f2f2f2;
  border-bottom: 1px solid #ddd;
}
.etc-modal-title {
  font-weight: bold;
}
.etc-modal-close {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 1.2rem;
}
.etc-modal-body {
  padding: 15px;
}
.etc-textarea {
  width: 100%;
  height: 100px;
  margin-top: 8px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: none;
  box-sizing: border-box;
}
.etc-modal-footer {
  padding: 10px;
  border-top: 1px solid #eee;
  text-align: right;
  gap: 8px;
  display: flex;
  justify-content: flex-end;
}
.etc-btn-submit {
  padding: 6px 12px;
  background: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.etc-btn-submit.collect{
  background: #beb8b8;
}
.etc-btn-submit.delete{
  background: #FF0000;
}
.etc-btn-cancle {
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.etc-input-date {
  width: 100%;
  margin-top: 8px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-family: "Malgun Gothic", sans-serif;
}

.form-item {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.combo-wrapper {
  position: relative;
  width: 100%;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 150px;
  overflow-y: auto;
  z-index: 100;
}

.dropdown li {
  padding: 8px;
  border-bottom: 1px solid #eee;
  color: #333;
}

.dropdown li:hover {
  background-color: #f0f0f0;
}

textarea{
  font-family: "Malgun Gothic", sans-serif;
}

/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  :deep(.ag-em-balham .ag-cell) {
    font-size: 0.9rem;
  }
  .em-total-table {
    font-size: 0.9rem;
  }
  .detail-table {
    font-size: 0.9rem;
  }
}
</style>
